<template>
    <PopForm v-if="show" width="990px" body-max-height="540px">
        <template #title>{{title}}</template>

        <!--内容-->
        <div class="content-wrap">
            <el-form ref="form" :model="formData" label-width="80px">
                <el-form-item label="标题">
                    <el-input v-model="formData.title"></el-input>
                </el-form-item>
                <el-form-item label="内容">
                    <Editor v-model="formData.content" path="notice/images/" class="editor-box" :menus="['image']" />
                </el-form-item>
            </el-form>
        </div>

        <template #foot>
            <div class="foot-box">
                <div class="left-box">
                    <!--<el-button type="default" size="mini">预览</el-button>-->
                </div>
                <div class="right-box">
                    <el-button type="default" size="medium" @click="close()">取消</el-button>
                    <el-button type="primary" size="medium" @click="submitEvent()">确定</el-button>
                </div>
            </div>
        </template>
    </PopForm>
</template>

<script>
    import PopForm from "@/model/PopForm";
    import Editor from "@/model/Editor";
    export default {
        name: "NoticeAddBox",
        components: {Editor, PopForm},
        model: {
            prop: "show",
            event: "showChange"
        },
        props: {
            show: {
                type: Boolean,
                default: false
            },
            id: {
                type: [String, Number],
                default: ""
            }
        },
        data(){
            return {
                title: "",
                formData: {}
            };
        },
        methods: {
            init(){
                this.formData = {};
                if(this.id) {
                    this.title = "修改公告";
                    this.getNoticeData();
                }else{
                    this.title = "发布公告";
                }
            },
            close(){
                this.$emit("showChange", false);
            },
            getNoticeData(){
                this.$root.postData("store_notice/get_data", {id: this.id}, res => {
                    if(res.errcode === 0){
                        this.formData = {
                            title: res.data.title,
                            content: res.data.content
                        };
                    }else{
                        this.$root.error(res.errdesc);
                    }
                });
            },
            submitEvent() {
                if(this.id) this.editSubmit();
                else this.addSubmit();
            },
            editSubmit(){
                let postData = {
                    id: this.id,
                    title: this.formData.title,
                    content: this.formData.content
                };
                this.$root.postData("store_notice/edit_data", postData, res => {
                    if(res.errcode === 0) {
                        this.$root.success("公告修改成功");
                        this.close();
                        this.$emit("success");
                    }else{
                        this.$root.error(res.errdesc);
                    }
                });
            },
            addSubmit() {
                this.$confirm("您确定发布公告？确定后，绑定了本门店的微信用户将立即收到此条公告。", "提示", {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then( () => {
                    let postData = {
                        title: this.formData.title,
                        content: this.formData.content
                    };
                    this.$root.postData("store_notice/add_data", postData, res => {
                        if(res.errcode === 0) {
                            this.$root.success("公告发布成功");
                            this.close();
                            this.$emit("success");
                        }else{
                            this.$root.error(res.errdesc);
                        }
                    });
                }).catch(() => {});
            }
        },
        watch: {
            show(val){
                if(val) this.init();
            }
        }
    }
</script>

<style scoped>
    .content-wrap{
        padding: 10px 82px 0 20px;
    }
    .el-form-item:last-child{
        margin-bottom: 0;
    }
    .foot-box{
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 20px 10px;
    }
    .foot-box .left-box,.foot-box .right-box{

    }
</style>
